import * as tracking from 'dibs-tracking';

export function trackSellerApplicationEvent(type: string, action: string): void {
    tracking.trackEvent({
        category: 'seller application',
        action: `${type} application ${action}`,
        label: `seller application - ${type}`,
        isInteractiveEvent: true,
    });
}
